import { Divider, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { lpCompany as rules } from 'further-ui/validations';
import FormField from 'further-ui/components/FormField';
import { useNotification } from 'hooks/ui/useNotification';
import useFileUpload from 'hooks/ui/useFileUpload';
import { UploadType } from 'further-types/files';
import CompanyStageSelector from 'components/CompanyStageSelector';
import CompanySectorSelector from 'components/CompanySectorSelector';
import { Column } from 'further-ui/components/Layout';
import LogoUpload from './LogoUpload';

const PortalInformation: React.FC = () => {
  const { control } = useFormContext<rules.CompanySchemaFormValues>();
  const { uploadFile } = useFileUpload();
  const { error } = useNotification();

  return (
    <Column spacing="lg">
      <Controller
        name="companyLogo"
        control={control}
        render={({ field: { onChange, value } }) => (
          <LogoUpload
            fileUrl={value?.preview}
            onChange={async (files) => {
              if (files === null) {
                onChange(null);
                return;
              }
              const file = files[0];
              if (!file) return;
              const result = await uploadFile(
                file.fileData,
                UploadType.CompanyLogos,
              );
              if (result.data) {
                onChange({
                  path: result.data.filePath,
                  name: result.data.name,
                  preview: result.data.url,
                });
              } else {
                error(result.error.message);
              }
            }}
          />
        )}
      />
      <Divider />
      <FormField label="Company description">
        <Controller
          name="description"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              variant="outlined"
              size="small"
              fullWidth
              multiline
              placeholder="Enter company description"
              rows={5}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </FormField>
      <FormField label="Company website">
        <Controller
          name="websiteUrl"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Enter company website"
            />
          )}
        />
      </FormField>
      <FormField label="Twitter/X URL">
        <Controller
          name="twitterUrl"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Enter Twitter/X URL"
            />
          )}
        />
      </FormField>
      <FormField label="LinkedIn URL">
        <Controller
          name="linkedinUrl"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Enter LinkedIn URL"
            />
          )}
        />
      </FormField>
      <Divider />
      <FormField label="Stage">
        <Controller
          name="stage"
          control={control}
          render={({ field: { value, onChange } }) => (
            <CompanyStageSelector
              value={value}
              onChange={onChange}
              name="stage"
              placeholder="Select stage"
            />
          )}
        />
      </FormField>
      <FormField label="Sector">
        <Controller
          name="sector"
          control={control}
          render={({ field: { value, onChange } }) => (
            <CompanySectorSelector
              value={value}
              onChange={onChange}
              name="sector"
              placeholder="Select sector"
            />
          )}
        />
      </FormField>
    </Column>
  );
};

export default PortalInformation;
